import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { FC } from 'react'

import style from './ImageItem.module.scss'

interface IImageItem {
  item: orderFormSpace.Images
}

export const ImageItem: FC<IImageItem> = ({ item }) => {
  if (!item.previewUrl) return <>img error!</>
  return (
    <div className={style.file}>
      <div className={style.fileInf}>
        <img src={item.previewUrl} alt={item.name} />
        <div className={style.fileTextInf}>
          <span className={style.fileName}>{item.name}</span>
          <span className='caption'>{item.size}</span>
        </div>
      </div>
    </div>
  )
}
